const features = [
  {
    icon: "ri-nurse-line",
    title: "RN-Led Instruction",
    description: "Every class is taught by credentialed Registered Nurses with hands-on clinical experience — not just certified trainers.",
  },
  {
    icon: "ri-time-line",
    title: "Same-Day Certification",
    description: "Complete your training and walk away certified the same day. No waiting, no delays — just immediate results.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "AHA-Aligned Training",
    description: "All courses follow American Heart Association guidelines, ensuring industry-recognized, high-quality certification.",
  },
  {
    icon: "ri-hand-heart-line",
    title: "Hands-On Training",
    description: "Real manikins, real AED trainers, real scenarios. We believe learning by doing creates truly prepared responders.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Easy, Fast Booking",
    description: "Book online in minutes. Same-day and next-day slots available to fit even the busiest schedules.",
  },
  {
    icon: "ri-group-line",
    title: "Group & Corporate Sessions",
    description: "Custom on-site training for teams, businesses, hospitals, and organizations. Flexible scheduling for groups of any size.",
  },
  {
    icon: "ri-building-line",
    title: "Professional Environment",
    description: "A welcoming, fully-equipped training center in Kissimmee designed to reflect the standards of real clinical settings.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Trusted & Credentialed",
    description: "Hundreds of students certified. A reputation built on medical expertise, professional excellence, and genuine care.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-brand-purple-pale text-brand-purple text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-4">
            The Cardiocraft Difference
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-brand-black mb-4">
            Why Choose <span className="text-brand-purple">Cardiocraft CPR</span>
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto mb-4" />
          <p className="text-gray-600 max-w-xl mx-auto text-lg">
            We set the standard for CPR and life support training in Kissimmee, FL.
          </p>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="p-6 rounded-xl bg-brand-purple-pale border border-brand-purple/10 hover:border-brand-purple/30 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-brand-purple rounded-lg text-white mb-4">
                <i className={`${feat.icon} text-xl`} />
              </div>
              <h3 className="font-semibold text-brand-black text-base mb-2">{feat.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
